import mixitup from 'mixitup';
import mixitupMultifilter from './mixitup-multifilter.min';
import mixitupPagination from './mixitup-pagination.min';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Animations from './animations';

mixitup.use(mixitupMultifilter);
mixitup.use(mixitupPagination);

const checkboxFilter = {
  // Declare any variables we will need as properties of the object

  $filters: null,
  $reset: null,
  groups: [],
  outputArray: [],
  outputString: '',
  mixer: null,

  // The "init" method will run on document ready and cache any jQuery objects we will need.

  init: function () {
    var self = this; // As a best practice, in each method we will asign "this" to the variable "self" so that it remains scope-agnostic. We will use it to refer to the parent "checkboxFilter" object so that we can share methods and properties between all parts of the object.

    self.$filters = $('#Filters, #Filters2');
    self.$reset = $('#Reset');
    self.$container = $('#wines-container');

    self.$filters.each(function () {
      var $fieldset = $(this).find('fieldset');
      if ($fieldset.length) {
        self.groups.push({
          $inputs: $fieldset.find('input'),
          active: [],
          tracker: false,
        });
      }
    });

    //console.log('Filter groups:', self.groups); // Debugging line
    self.bindHandlers();
  },

  // The "bindHandlers" method will listen for whenever a form value changes.

  bindHandlers: function () {
    var self = this;

    self.$filters.on('change', function () {
      self.parseFilters();
    });

    self.$reset.on('click', function (e) {
      e.preventDefault();
      console.log('Filters element:', self.$filters); // Check if this logs the correct element
      console.log('Is filters a form?', self.$filters.is('form')); // Should log true if it's a form
      try {
        self.$filters[0].reset();
        console.log('Form reset successfully');
      } catch (error) {
        console.error('Error resetting form:', error);
      }
      self.parseFilters();
      console.log('Reset button clicked');
    });
  },

  // The parseFilters method checks which filters are active in each group:

  parseFilters: function () {
    var self = this;
    console.log('Starting parseFilters...');

    // Reset all groups before parsing
    self.groups = [];
    self.outputArray = []; // Reset output array
    self.outputString = ''; // Reset output string

    // Get the active form (either desktop or mobile)
    var $activeForm = $(window.innerWidth <= 768 ? '#Filters2' : '#Filters');

    // Only process the active form
    $activeForm.find('fieldset').each(function () {
      var $fieldset = $(this);
      var group = {
        $inputs: $fieldset.find('input'),
        active: [],
        tracker: false,
        category: $fieldset.attr('data-category'),
      };

      group.$inputs.each(function () {
        if ($(this).is(':checked')) {
          group.active.push({
            value: this.value,
            category: group.category,
          });
        }
      });

      if (group.active.length) {
        group.tracker = 0;
      }

      self.groups.push(group);
    });

    console.log('Groups after parsing:', self.groups);
    self.concatenate();
  },

  // The "concatenate" method will crawl through each group, concatenating filters as desired:

  concatenate: function () {
    var self = this;
    console.log('Starting concatenate...');
    // Reset output array and string
    self.outputArray = [];
    self.outputString = '';

    var filterValues = [],
      crawled = false,
      checkTrackers = function () {
        var done = 0;
        for (var i = 0, group; (group = self.groups[i]); i++) {
          group.tracker === false && done++;
        }
        return done < self.groups.length;
      };

    // Check if any groups have active filters
    var hasActiveFilters = self.groups.some(function (group) {
      return group.active.length > 0;
    });

    if (!hasActiveFilters) {
      self.outputString = 'all';
      // Clear URL and storage when no filters are active
      history.pushState(null, '', '/shop/');
      filterStateManager.clearState();
      return;
    }

    var crawl = function () {
        for (var i = 0, group; (group = self.groups[i]); i++) {
          if (group.active[group.tracker]) {
            filterValues.push(group.active[group.tracker].value);
          }
          if (i === self.groups.length - 1) {
            self.outputArray.push(filterValues.join(''));
            filterValues = [];
            updateTrackers();
          }
        }
      },
      updateTrackers = function () {
        for (var i = self.groups.length - 1; i > -1; i--) {
          var group = self.groups[i];
          if (group.active[group.tracker + 1]) {
            group.tracker++;
            break;
          } else if (i > 0) {
            group.tracker && (group.tracker = 0);
          } else {
            crawled = true;
          }
        }
      };

    do {
      crawl();
    } while (!crawled && checkTrackers());

    self.outputString = self.outputArray.join();
    console.log('Output string after concatenate:', self.outputString);

    // If the output string is empty, show all rather than none:
    !self.outputString.length && (self.outputString = 'all');

    if (self.mixer.isLoaded) {
      self.mixer.filter(self.outputString);
    }
  },

  // New function to update URL hash when filters change
  updateUrlHash: function () {
    var selectedFilters = [];
    var uniqueFilters = new Set();

    this.groups.forEach(function (group) {
      if (group.active.length) {
        group.active.forEach(function (filter) {
          uniqueFilters.add(`${filter.category}:${filter.value.replace('.', '')}`);
        });
      }
    });

    selectedFilters = Array.from(uniqueFilters);

    if (selectedFilters.length > 0) {
      window.location.hash = selectedFilters.join('+');
      filterStateManager.saveState();
    } else {
      window.location.hash = '';
      filterStateManager.clearState();
    }
  },

  // New function to apply hash filters on page load
  applyHashFilters: function () {
    var hash = window.location.hash.replace('#', '');
    if (hash) {
      var filters = Array.from(new Set(hash.split('+'))); // Remove duplicates
      // Set the checked state of the corresponding checkboxes
      filters.forEach((filter) => {
        var [category, value] = filter.split(':');
        var checkbox = $(`fieldset[data-category="${category}"] input[value=".${value}"]`);
        if (checkbox.length) {
          checkbox.prop('checked', true);
        }
      });
      this.parseFilters();
      checkboxFilter.mixer.filter(checkboxFilter.outputString);
    }
  },

  // Add separate URL hash handling for mobile
  updateMobileUrlHash: function () {
    var selectedFilters = [];
    var uniqueFilters = new Set();

    this.groups.forEach(function (group) {
      if (group.active.length) {
        group.active.forEach(function (filter) {
          uniqueFilters.add(`${filter.category}:${filter.value.replace('.', '')}`);
        });
      }
    });

    selectedFilters = Array.from(uniqueFilters);

    if (selectedFilters.length > 0) {
      window.location.hash = selectedFilters.join('+');
      filterStateManager.saveState();
    } else {
      window.location.hash = '';
      filterStateManager.clearState();
    }
  },
};

// Add filter state persistence
const filterStateManager = {
  getStorageKey: function () {
    return window.innerWidth <= 768 ? 'wineFiltersMobile' : 'wineFilters';
  },

  saveState: function () {
    // Build the filter state from active filters
    const activeFilters = [];
    checkboxFilter.groups.forEach(function (group) {
      if (group.active.length) {
        group.active.forEach(function (filter) {
          activeFilters.push(`${filter.category}:${filter.value.replace('.', '')}`);
        });
      }
    });

    const filterState = {
      hash: activeFilters.length > 0 ? activeFilters.join('+') : '',
      timestamp: new Date().getTime(),
    };

    // Only save if we have active filters
    if (activeFilters.length > 0) {
      localStorage.setItem(this.getStorageKey(), JSON.stringify(filterState));
    } else {
      localStorage.removeItem(this.getStorageKey());
    }
  },

  loadState: function () {
    const state = JSON.parse(localStorage.getItem(this.getStorageKey()));
    if (!state) return null;

    // Clear state if it's older than 30 minutes
    if (new Date().getTime() - state.timestamp > 30 * 60 * 1000) {
      localStorage.removeItem(this.getStorageKey());
      return null;
    }
    return state;
  },

  clearState: function () {
    localStorage.removeItem(this.getStorageKey());
    this.updateResetButton();
    window.location.hash = '';
  },

  applyState: function () {
    const state = this.loadState();
    if (state && state.hash) {
      // Split the hash into individual filters
      const filters = state.hash.split('+');

      // Reset all checkboxes first
      $('.filter-input').prop('checked', false);

      // Check the appropriate checkboxes
      filters.forEach((filter) => {
        const [category, value] = filter.split(':');
        $(`.filter-input[value=".${value}"]`).prop('checked', true);
      });

      // Update URL without triggering hashchange
      window.location.hash = state.hash;

      // Force filter update
      checkboxFilter.parseFilters();
      checkboxFilter.mixer.filter(checkboxFilter.outputString);

      // Update UI state
      filterStateManager.updateResetButton();
      ScrollTrigger.refresh();
    }
  },

  updateResetButton: function () {
    const resetBtn = window.innerWidth <= 768 ? $('#ResetMobile') : $('#Reset');
    if (resetBtn.length) {
      const hasActiveFilters = $('.filter-input:checked').length > 0;
      resetBtn.prop('disabled', !hasActiveFilters);
    }
  },
};

class EventsFilter {
  constructor() {
    this.mixer = null;
    this.toggle = $('#sort-by-toggle');
    this.menu = $('#sort-by-menu');
    this.select = $('#sort-by');

    // Set initial text
    this.toggle.find('span#selected-option').text('All Events');
  }

  init() {
    if (!$('.js-eventsSortBy').length) return;
    this.initMixer();
    this.bindEvents();
    this.cleanupEventMonths();
  }

  initMixer() {
    this.mixer = mixitup('#events-grid', {
      selectors: {
        target: '.event-item',
      },
      animation: {
        duration: 300,
        effects: 'fade translateZ(-100px)',
      },
      callbacks: {
        onMixEnd: function (state) {
          ScrollTrigger.refresh();
          // Check if any events are shown
          if (state.totalShow === 0) {
            if (!$('#no-events-message').length) {
              $('#events-grid').append('<div id="no-events-message" class="no-events">No events found, please try again soon.</div>');
            }
          } else {
            $('#no-events-message').remove();
          }
        },
      },
    });
  }

  bindEvents() {
    // Dropdown toggle
    this.toggle.on('click', () => {
      this.menu.toggle();
    });

    // Dropdown item selection
    $('.dropdown-item').on('click', (e) => {
      const $target = $(e.currentTarget);
      const value = $target.data('value');
      const text = value === 'all' ? 'All Events' : $target.text();

      $('.dropdown-item').removeClass('active');
      this.toggle.find('span#selected-option').text(text);
      this.select.val(value);
      this.menu.hide();
      this.select.trigger('change');
      $target.addClass('active');
    });

    // Close dropdown when clicking outside
    $(document).on('click', (e) => {
      if (!$(e.target).closest('.custom-dropdown').length) {
        this.menu.hide();
      }
    });

    // Handle filter changes
    this.select.on('change', (e) => {
      const value = e.target.value;
      this.mixer.filter(value);
    });
  }

  cleanupEventMonths() {
    $('.event-item').each(function () {
      const $event = $(this);
      const validMonths = new Set();

      // Check each visible date element
      $event.find('.eyebrow.pine-tree:visible').each(function () {
        const dateText = $(this).text().toLowerCase();

        // Check for each month
        ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'].forEach((month) => {
          if (dateText.includes(month)) {
            validMonths.add(month);
          }
        });
      });

      // Remove invalid month classes
      ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'].forEach((month) => {
        if ($event.hasClass(month) && !validMonths.has(month)) {
          $event.removeClass(month);
        }
      });
    });
  }
}

// On document ready, initialise our code.

$(function () {
  if ($('.js-shopWinesTrigger').length) {
    let isFiltering = false;

    // Initialize checkboxFilter code first
    checkboxFilter.init();

    // Initialize MixItUp
    checkboxFilter.mixer = mixitup('#wines-container', {
      selectors: {
        target: '.mix',
      },
      animation: {
        duration: 300,
        effects: 'fade translateZ(-100px)',
      },
      callbacks: {
        onMixEnd: function () {
          $('.merch-cards').hide();
          ScrollTrigger.refresh();
          Animations.activeSubNav();
        },
      },
    });

    // Check for hash in URL first
    if (window.location.hash) {
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        const filters = hash.split('+');
        // Reset all checkboxes first
        $('.filter-input').prop('checked', false);

        // Check the appropriate checkboxes
        filters.forEach((filter) => {
          const [category, value] = filter.split(':');
          $(`.filter-input[value=".${value}"]`).prop('checked', true);
        });

        // Apply filters
        checkboxFilter.parseFilters();
        checkboxFilter.mixer.filter(checkboxFilter.outputString);
        filterStateManager.updateResetButton();
      }
    } else {
      // If no hash, check if we're coming back from a product page
      const preserveFilters = document.referrer.includes('/wine/');
      if (preserveFilters) {
        filterStateManager.applyState();
      } else {
        filterStateManager.clearState();
      }
    }

    // Handle hash changes
    $(window).on('hashchange', function () {
      if (window.location.hash) {
        checkboxFilter.applyHashFilters();
      }
    });

    // Bind filter change event
    $('#Filters input, #Filters2 input').on('change', function () {
      if (!isFiltering) {
        isFiltering = true;

        checkboxFilter.parseFilters();
        checkboxFilter.mixer.filter(checkboxFilter.outputString);

        // Only update URL and storage if there are active filters
        if ($('.filter-input:checked').length > 0) {
          if ($(this).closest('#Filters').length) {
            checkboxFilter.updateUrlHash();
            filterStateManager.saveState();
          } else if ($(this).closest('#Filters2').length) {
            checkboxFilter.updateMobileUrlHash();
            filterStateManager.saveState();
          }
        } else {
          filterStateManager.clearState();
        }

        ScrollTrigger.refresh();
        filterStateManager.updateResetButton();

        isFiltering = false;
      }
    });

    // Simplify the reset handlers
    $('#Reset, #ResetMobile').on('click', function () {
      $('.filter-input:checked').prop('checked', false);
      checkboxFilter.mixer.filter('all');
      // Clear appropriate storage based on which reset button was clicked
      if ($(this).attr('id') === 'ResetMobile') {
        localStorage.removeItem('wineFiltersMobile');
      } else {
        localStorage.removeItem('wineFilters');
      }
      // Clear URL hash
      window.location.hash = '';
      filterStateManager.updateResetButton();
    });

    // Initialize reset button state
    filterStateManager.updateResetButton();
  }

  // Initialize events filter
  if ($('.js-eventsSortBy')[0]) {
    const eventsFilter = new EventsFilter();
    eventsFilter.init();
  }
});

export { checkboxFilter, EventsFilter };
